import Card from 'react-bootstrap/Card'
import { userMaintenance } from '../../helpers/APIHelper'
import React from 'react';
import Button  from 'react-bootstrap/Button'
import { Formik } from 'formik'
import { Form, Alert  } from 'react-bootstrap'
import { InputGroup } from 'react-bootstrap'
import * as yup from "yup";
import ErrorModal from '../../components/modals/ErrorModal'
import Bubbles from '../loading/Bubbles';
import { RECAPTCHA_SITE_KEY } from '../../helpers/APIConfig'
import ReCAPTCHA from 'react-google-recaptcha';

const ChangePin = ( {setAuthentication} ) => {
    
    const [modalShow, setModalShow] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [isLoading, setLoading] = React.useState(false)
    const [isSuccess, setSuccess] = React.useState(false);
    const recaptchaRef = React.useRef(null);

    const schema = yup.object().shape({
        currentPin: yup.string().required("Current pin is required."),
        newPin: yup.string().required("New pin is required."),
        confirmPin: yup.string().required("Confirm pin is required."),
        currentPassword: yup.string().required("Current password is required."),
    });

    return (
        <Card className="ran-card">
            <Card.Header className="ran-card-header text-white">CHANGE PIN CODE</Card.Header>
            <Card.Body>
                <>
                            {
                                isSuccess &&
                                <Alert variant="info" >
                                    Pin code has been successfully updated.
                                </Alert>
                            }
                             <Formik
                                initialValues={{
                                    currentPin: "",
                                    newPin:"",
                                    confirmPin: "",
                                    currentPassword:""
                                }}
                                onSubmit={async (values, {resetForm}) => {
                                    setLoading(true)
                                    setSuccess(false)

                                    const captchaToken = await recaptchaRef.current.executeAsync();
                                    recaptchaRef.current.reset();

                                    const payload = {
                                        ...values,
                                        captchaToken
                                    };
                                    
                                    var result = await userMaintenance('PINCODE', payload, setAuthentication);
                                    if(result !== null || result !== undefined){
                                        if(result.success) {
                                            setLoading(false)
                                            setSuccess(true)
                                            resetForm({
                                                currentPin: "",
                                                newPin:"",
                                                confirmPin: "",
                                                currentPassword:""
                                            })
                                        }
                                        else{
                                            // not found or bad request.
                                            if(result.status === 404 || result.status === 400){
                                                setModalShow(true)
                                                setErrors(result.errors)
                                                setLoading(false)
                                            }
                                            // do nothing if unauthorize.
                                        }
                                    }
                                }}
                                validationSchema={schema}>
                                {({
                                errors,
                                touched,
                                handleBlur,
                                handleChange,
                                isSubmitting,
                                values,
                                handleSubmit
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Group md="4" controlId="validateFormCurrentPinCode">
                                            <Form.Label>Current Pin Code</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                type="password"
                                                placeholder="Current Pin Code"
                                                name="currentPin"
                                                value={values.currentPin}
                                                onChange={handleChange}
                                                isInvalid={!!errors.currentPin}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                {errors.currentPin}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group md="4" controlId="validateFormNewPin" className="mt-2">
                                            <Form.Label>New Pin Code</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                type="password"
                                                placeholder="New Pin Code"
                                                name="newPin"
                                                value={values.newPin}
                                                onChange={handleChange}
                                                isInvalid={!!errors.newPin}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                {errors.newPin}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group md="4" controlId="validateFormConfirmNewPin" className="mt-2">
                                            <Form.Label>Confirm New Pin Code</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                type="password"
                                                placeholder="Confirm New Pin Code"
                                                name="confirmPin"
                                                value={values.confirmPin}
                                                onChange={handleChange}
                                                isInvalid={!!errors.confirmPin}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                {errors.confirmPin}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group md="4" controlId="validateFormCurrentPassword" className="mt-2">
                                            <Form.Label>Curent Password</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                type="password"
                                                placeholder="Curent Password"
                                                name="currentPassword"
                                                value={values.currentPassword}
                                                onChange={handleChange}
                                                isInvalid={!!errors.currentPassword}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                {errors.currentPassword}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>
                                        {
                                            isLoading && 
                                            (
                                                <div className="mt-3">
                                                   <Bubbles />
                                                </div>
                                            )
                                        }
                                        <Form.Group  className="mt-4 mb-0">
                                            <Button  disabled={isLoading} type="submit" variant="warning" className="btn-danger text-white" style={{float:"right"}}>
                                                            {
                                                                isLoading ? 'PROCESSING' : 'CHANGE PIN CODE'
                                                            }
                                            </Button>
                                        </Form.Group>
                                </Form>
                                )}
                            </Formik>
                            <ReCAPTCHA
                                sitekey={RECAPTCHA_SITE_KEY}
                                size="invisible"
                                ref={recaptchaRef}
                            />
                            <ErrorModal
                                errors={errors}
                                show={modalShow}
                                onHide={() => setModalShow(false)}/>
                        </>
            </Card.Body>
        </Card>
    )
}

export default ChangePin
